import {call, select, takeEvery} from 'redux-saga/effects'

import * as rtkActions from '../../actions/rentToKeep'
import * as rtkSelectors from '../../store/rentToKeep'
import * as track from '../../track/track'

export function* trackViewedRentToKeepShoppingPageWorker() {
  yield call(track.viewedRentToKeepShoppingPage)
}

export function* trackViewedRentToKeepShoppingPageSaga() {
  yield takeEvery(rtkActions.START_RTK_FLOW, trackViewedRentToKeepShoppingPageWorker)
}

export function* trackAddedRentToKeepProductsWorker({payload: items}) {
  yield call(track.addedRentToKeepProducts, items)
}

export function* trackAddedRentToKeepProductsSaga() {
  yield takeEvery(rtkActions.SUBMIT_SELECT_ITEMS, trackAddedRentToKeepProductsWorker)
}

export function* trackRTKBillingFormSubmittedWorker() {
  const isChargingCardOnFile = yield select(rtkSelectors.isChargingCardOnFile)
  yield call(track.checkoutSubmittedPaymentInfo, {isChargingCardOnFile})
}

export function* trackRTKBillingFormSubmittedSaga() {
  yield takeEvery(rtkActions.SUBMIT_BILLING_STEP, trackRTKBillingFormSubmittedWorker)
}

export function* trackClickedRentToKeepCheckoutSubmitWorker() {
  yield call(track.clickedRentToKeepCheckoutSubmit)
}

export function* trackClickedRentToKeepCheckoutSubmitSaga() {
  yield takeEvery(rtkActions.SUBMIT_RTK_PURCHASE, trackClickedRentToKeepCheckoutSubmitWorker)
}
